var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 4.33203V12.332H10.6667V4.33203H1.33333ZM1.33333 2.9987H10.6667V1.66536H1.33333V2.9987ZM11.3333 13.6654H0.666667C0.489856 13.6654 0.320286 13.5951 0.195262 13.4701C0.0702379 13.3451 0 13.1755 0 12.9987V0.998698C0 0.821887 0.0702379 0.652318 0.195262 0.527293C0.320286 0.402269 0.489856 0.332031 0.666667 0.332031H11.3333C11.5101 0.332031 11.6797 0.402269 11.8047 0.527293C11.9298 0.652318 12 0.821887 12 0.998698V12.9987C12 13.1755 11.9298 13.3451 11.8047 13.4701C11.6797 13.5951 11.5101 13.6654 11.3333 13.6654ZM2.66667 5.66536H5.33333V8.33203H2.66667V5.66536ZM2.66667 9.66536H9.33333V10.9987H2.66667V9.66536ZM6.66667 6.33203H9.33333V7.66536H6.66667V6.33203Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d5b66f36f52d24fc7f7ba81ff6e7576b.svg";
export { ForwardRef as ReactComponent };